export default __webpack_public_path__ + "static-front/media/VerticalIcon.0bd43a11.svg";